import api from '@/api';

import {
  AffectPriceRequest,
  CompanyConsumableStockPricesRequest,
  CompanyPartStockPricesRequest,
  ConsumableStockPrices,
  ListStockItemsQuery,
  PartStockPrices,
  StockItem,
} from './StockItems.types';
import { API_BASE_URL } from '..';
import { PageResultStock } from '@/core/request/PageResultStock';

const CONTROLLER_URL = `${API_BASE_URL}`;

export async function listStockItems(
  params: ListStockItemsQuery,
): Promise<PageResultStock<StockItem>> {
  const result = (await api.get(`${CONTROLLER_URL}/items`, params)) as unknown;

  return result as PageResultStock<StockItem>;
}

export async function listPartStockPrices(partId?: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/part-prices/parts/${partId}`,
    {
      active: true,
    },
  )) as unknown;

  return result as PartStockPrices;
}

export async function affectPrice(obj: AffectPriceRequest) {
  const result = (await api.post(
    `${CONTROLLER_URL}/part-prices`,
    obj,
    null,
  )) as unknown;

  return result;
}

export async function companyPartStockPrices(
  req: CompanyPartStockPricesRequest,
): Promise<PartStockPrices> {
  const result = (await api.post(
    `${CONTROLLER_URL}/part-prices/parts/${req.partId}`,
    req,
    null,
  )) as unknown;

  return result as PartStockPrices;
}

export async function listConsumableStockPrices(
  partId: number,
): Promise<ConsumableStockPrices> {
  const result = (await api.get(
    `${CONTROLLER_URL}/consumable-prices/consumables/${partId}`,
    null,
  )) as unknown;

  return result as ConsumableStockPrices;
}

export async function companyConsumableStockPrices(
  req: CompanyConsumableStockPricesRequest,
): Promise<ConsumableStockPrices> {
  const result = (await api.post(
    `${CONTROLLER_URL}/consumable-prices/consumables/${req.consumableId}`,
    req,
    null,
  )) as unknown;

  return result as ConsumableStockPrices;
}
